import {gsap} from "gsap/gsap-core";

export const tickup = (
    from: number,
    to: number,
    duration_ms = 1000,
    onUpdate: (val: number) => void
) => {
    const obj = {value: from};
    gsap.fromTo(obj, obj, {
        duration: duration_ms * 0.001,
        value: to,
        ease: "linear",
        onUpdate: () => onUpdate(obj.value)
    });
    return () => gsap.killTweensOf(obj);
};
